import React from 'react';
import styled from 'styled-components';

interface ReportHeaderProps {
  title: string;
  subtitle?: string;
  rightActions?: React.ReactNode;
}

const Header = styled.div`
  padding: 16px;
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

const Left = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`;

// botão de voltar removido por solicitação

const TitleBox = styled.div`
  display: flex;
  flex-direction: column;
`;

const Title = styled.h2`
  margin: 0;
  font-size: 18px;
`;

const Subtitle = styled.div`
  font-size: 12px;
  color: #6b7280;
`;

const Right = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

const ReportHeader: React.FC<ReportHeaderProps> = ({ title, subtitle, rightActions }) => {

  return (
    <Header>
      <Left>
        <TitleBox>
          <Title>{title}</Title>
          {subtitle && <Subtitle>{subtitle}</Subtitle>}
        </TitleBox>
      </Left>
      <Right>
        {rightActions}
      </Right>
    </Header>
  );
};

export default ReportHeader;


